import { render } from "./RecentlyScannedGuests.vue?vue&type=template&id=eeda1b76"
import script from "./RecentlyScannedGuests.vue?vue&type=script&lang=js"
export * from "./RecentlyScannedGuests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__